import { icon } from "@/constants";
import { Link, useParams } from "react-router-dom";

const Index = () => {
    const { businessName } = useParams();
    return (
        <div className="relative bg-primary w-full h-20 padding-x">
            <Link to={`/${businessName}`}>
                <img className="absolute top-12 h-16 rounded-full" src={`../${icon}`} alt="logo" />
            </Link>
        </div>
    );
};

export default Index;
